<div class="row p-1">
  <div class="col-12 pageTitle">
    <h2>&nbsp;&nbsp;&nbsp;Security Question List</h2>
  </div>
</div>

<div class="field col-2 md:col-2 mb-2">
  <button
    pButton
    type="button"
    pTooltip=""
    label="Create Question"
    pTooltipPosition="true"
    icon="pi pi-book"
    class="ui-button-plain buttonWidth-12 GreyButton"
    (click)="onAddQuestion()"
  ></button>
</div>

<p-table
   *ngIf="questions"
[responsive]="true"
[columns]="cols"
[value]="questions.data"
selectionMode="single"
dataKey="questionId"
[resetPageOnSort]="false"
[lazy]="false"
[rows]="rows"
[paginator]="showRecords"
(sortFunction)="customSort($event, 1)"
[customSort]="true"
>
  <ng-template pTemplate="header" let-columns>
    <tr *ngIf="showRecords == true">
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{ col.header }}
        <p-sortIcon
          [field]="col.field"
          ariaLabel="Activate to sort"
          ariaLabelDesc="Activate to sort in descending order"
          ariaLabelAsc="Activate to sort in ascending order"
        ></p-sortIcon>
      </th>
      <th
        class="col-1 md:col-2 lg:col-1 xl:col-1 xs:col-2"
        style="text-align: center !important"
      >
        Actions
      </th>
    </tr>



  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <td>
        {{ rowData['description'] }}
      </td>
      <td class="col-2 md:col-1" style="text-align: center !important">
        <button
          pButton
          type="button"
          icon="pi pi-pencil"
          pTooltip="Edit"
          class="p-button-link"
          (click)="onEdit(rowData)"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-trash"
          pTooltip="Delete"
          class="p-button-link ml-3"
          (click)="dropQuestion($event, rowData['questionId'])"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <div class="w-12 bg-white">
      <div class="" style="text-align: center">
        <img
          _ngcontent-ng-c683320295=""
          class="profile-image"
          style="border-radius: 50%; width: 10rem; padding-top: 1rem"
          src="assets/imagesNew/table_error.png"
        />
      </div>
      <hr style="margin-bottom: 0.5rem" />
      <div
        class=""
        style="text-align: center; font-size: larger; color: #1d428f"
      >
        <i>No records found</i>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="paginatorleft" let-state>
    Showing {{ state.page * state.rows + 1 }} to
    {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }}
    records.
  </ng-template>
</p-table>

<p-dialog
  *ngIf="updateQuestion"
  [header]="questionOperation"
  [(visible)]="updateQuestion"
  [modal]="true"
  [responsive]="true"
  [style]="{ minWidth: '400px' }"
  [minY]="70"
  [maximizable]="true"
  [baseZIndex]="10000"
>
  <div class="card">
    <div class="col-12">
      <strong> <h4>Question Desciption:</h4> </strong>
      <textarea
        [(ngModel)]="question.description"
        [cols]="80"
        pInputTextarea
        class="col-12 md:col-12"
      ></textarea>
    </div>
    <div class="col-12">
      <button
        pButton
        type="submit"
        icon="pi pi-save"
        (click)="saveQuestion(question)"
        label="Save"
        class="p-button-plain buttonWidth-8 fl"
      ></button>
    </div>
  </div>
</p-dialog>
